import './Footer.scss';

import parse from 'html-react-parser';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '../../hooks/useMediaQuery';
import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';
import Button from '../buttons/Button';
import { AppLogo } from '../SVGIcons/AppLogo/AppLogo';

const Footer = observer(({ rspBtnType = 'main' }: { rspBtnType?: 'main' | 'purple' }) => {
  const { t } = useTranslation();

  const { cmsStore, authStore, liveGeoStore } = useStores();

  const isMobile = useMediaQuery('(max-width: 768px)');

  const { currentGeo } = liveGeoStore;
  const { territoryLegalAge } = currentGeo ?? { territoryLegalAge: 18 };

  const preventMultisession = useFlag('prevent_multisession_enable', false);

  const { footer } = cmsStore;

  if (!authStore.isAuthenticationFlowDone || (preventMultisession && authStore.isDisconnectedByMultisession)) {
    return null;
  }

  return (
    <footer className="site-footer">
      <AppLogo
        alwaysColorful
        withText
        className="footer-logo"
        textClassname="footer-logo-text"
        textColor="white"
        width={isMobile ? 109 : 148}
      />
      <div className="footer-top">
        <div className="footer-top-texts">
          <p className="footer-top-text first">{t('footer.headerTexts.first')}</p>
          <p className="footer-top-text second">{t('footer.headerTexts.second')}</p>
        </div>
        <Button btnType={rspBtnType} className="rsp-button" classNameWrapper="rsp-button-wrapper">
          <a href={'/pages/responsible-social-play'} rel="noopener noreferrer" target="_blank">
            {t('footer.rsp')}
          </a>
        </Button>
        {territoryLegalAge && <div className="age-limit">{territoryLegalAge}+</div>}
      </div>
      {footer && parse(footer)}
    </footer>
  );
});

export { Footer };
